module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/babel-runtime/core-js/get-iterator.js
// module id = 1020
// module chunks = 1